import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux'
import { setOfferId, setLeadId } from './../app-context/policyProduction';
import { Type } from '../models/superbit-api-models';
import OfferProduction from '../production/_OfferProduction';


type Props = {
    offer: any;
    onGoToSimulatorClick: (e: string) => void;
    onEdit: (e: string) => void;
}

const LeadOfferProduction: React.FC<Props> = ({ offer, onGoToSimulatorClick, onEdit }) => {

    const dispatch = useDispatch()
const [logData, setLogData] = useState<string>("");
    const [copied, setCopied] = useState<boolean>(false);

    const closeProduction = () => {

        dispatch(setOfferId(null));


    }

    const showOfferLog = (log:string)=>{
        
        log = log.replaceAll("&amp;", "&").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&lt;", "<");
        setLogData(log);
        setCopied(false);
        
      }

     const clearOfferLog = ()=>{
        setLogData("");
      }

      const copyToClipboard=async ()=>{
        await navigator.clipboard.writeText(logData);
        setCopied(true);
      }


    return (
        <div>

            <OfferProduction offer={offer} closeProduction={closeProduction} onGoToSimulatorClick={(e: string) => onGoToSimulatorClick(e)} onEdit={(e: string) =>onEdit(e)} showLog={showOfferLog}/>

 <div className={logData.length>0?"popup-wrapper":"popup-wrapper hide"}>
            <section className="popup-window rtl">
                <div onClick={() => clearOfferLog()} className="close-icon pointer"></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                          לוג
                        </div>
                    </div>
                    <div className="popup-body">
                        {logData}
                    </div>
                    <div className="popup-footer">
                        <button onClick={() => clearOfferLog()} className="button blue">
                            סגור
                        </button>
                        <button onClick={() => copyToClipboard()} className={copied?"":"button blue"}   >
                            העתק
                        </button>
                    </div>
                </div>
            </section>
          </div>

        </div>
    )
}

export default LeadOfferProduction